import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Form,
  Container,
  Button,
  FormGroup,
  Alert,
  Card,
  Image,
} from "react-bootstrap";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
// import Select from "react-select";
import { connect } from "react-redux";
import { isEmpty, isNumber } from "lodash";
import Spinner from "react-bootstrap/Spinner";
import MaterialSize from "material-table";
import "jspdf-autotable";
import Swal from "sweetalert";
import ImageUploader from "react-images-upload";
import logo from "../../../Images/logo.png";
import TextField from "@mui/material/TextField";
import { InputAdornment } from "@mui/material";

import DriveFileRenameOutlineTwoToneIcon from "@mui/icons-material/DriveFileRenameOutlineTwoTone";
import NumbersTwoToneIcon from "@mui/icons-material/NumbersTwoTone";

import { addCountry } from "./Country.action";
import { setHeading } from "../../user_views/accounts/account.actions";
// import { addHall } from "./Hall.action";
// import { getRestaurantData } from "../AddResturant/Resturant.action";
// import { setHeading } from "../../../accounts/account.actions";
// import { getUserRes } from "../../AddUser/user.actions";
const AddCountry = (props) => {
  const [name, setName] = useState("");
  const [countryCode, setCountryCode] = useState();

  const [visibleAlert, setAlertVisible] = useState(false);
  const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);

  const handleVisible = (msg) => {
    setAlertVisible(true);
    setTimeout(() => {
      setAlertVisible(false);
    }, 9000);
    Swal({
      title: "Success",
      text: msg,
      icon: "success",
      button: "Ok",
    });
  };

  const handleDangerVisible = (err) => {
    setDangerVisibleAlert(true);
    setTimeout(() => {
      setDangerVisibleAlert(false);
    }, 9000);
    Swal({
      title: "Error",
      text: err,
      icon: "error",
      button: "Ok",
    });
  };

  function saveCountry() {
    props.addCountry(
      {
        name: name,
        code: countryCode,
      },
      handleVisible,
      handleDangerVisible
    );
    setName("");
    setCountryCode("");
  }

  const [nameError, setNameError] = useState(false);

  const handleNameChange = (e) => {
    setName(e.target.value.toUpperCase());
    if (e.target.value.length > 3) {
      setNameError(false);
    } else {
      setNameError(true);
    }
  };

  useEffect(() => {
    props.setHeading("Add Hall");
    document.title = props.title;
    // props.getRole()
  }, []);
  return (
    <>
      <Container fluid>
        <div
          className="main"
          style={{
            height: "auto",
            borderRadius: "30px",
            boxShadow:
              " 0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
          }}
        >
          <Row style={{ marginTop: "35px" }}>
            <Col xl="3" lg="3" md="3" sm="3" xs="12">
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <DriveFileRenameOutlineTwoToneIcon />
                    </InputAdornment>
                  ),
                }}
                type="text"
                id="standard-basic"
                variant="standard"
                required
                error={nameError}
                value={name}
                helperText={
                  nameError
                    ? "Please Enter Your Country Name (Atleast 3 Character)"
                    : ""
                }
                label="Country Name"
                onChange={(e) => handleNameChange(e)}
                sx={{
                  width: "100%",
                }}
              />
            </Col>
            <Col xl="3" lg="3" md="3" sm="3" xs="12">
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <NumbersTwoToneIcon />
                    </InputAdornment>
                  ),
                }}
                type="Number"
                id="standard-basic"
                variant="standard"
                required
                value={countryCode}
                label="Country Code "
                onChange={(e) => setCountryCode(e.target.value)}
                sx={{
                  width: "100%",
                  "input::-webkit-outer-spin-button, input::-webkit-inner-spin-button":
                    {
                      WebkitAppearance: "none",
                      margin: 0,
                    },
                  "input[type=number]": {
                    MozAppearance: "textfield",
                  },
                }}
              />
            </Col>
          </Row>

          <div className="sendDiv" style={{ marginTop: "15px" }}>
            {props.isAddingCountry ? (
              <div className="loader-div">
                <Spinner
                  variant="secondary"
                  animation="grow"
                  size="xl"
                  role="status"
                  aria-hidden="true"
                />
              </div>
            ) : (
              <Button
                disabled={isEmpty(name) || isEmpty(countryCode)}
                style={{
                  marginLeft: "2%",
                  color: "black",
                  width: "20%",
                  backgroundColor: "#C5CBCF",
                  border: "1px solid white",
                }}
                onClick={saveCountry}
              >
                Save
              </Button>
            )}
          </div>
        </div>
      </Container>
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    addCountry: (data, handleVisible, handleDangerVisible) =>
      dispatch(addCountry(data, handleVisible, handleDangerVisible)),
    // getRestaurantData: () => dispatch(getRestaurantData()),
    setHeading: (data) => dispatch(setHeading(data)),
    // getUser: () => dispatch(getUserRes()),
    // imageFront: (data) => dispatch(addImage(data)),
    // imageBack: (data) => dispatch(addImageBack(data)),
    // companyLogo: (data) => dispatch(addLogo(data)),
    // getRole: () => dispatch(getRole()),
  };
};
const mapStateToProps = (state, ownProps) => ({
  country: state.CargoCountryReducer.country,
  isAddingCountry: state.CargoCountryReducer.isAddingCountry,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddCountry);
